import { useEffect, useState } from 'react';

import { useMenu } from 'global/MenuContext';
import { MenuItem, isMeetingRoomExtras } from 'types/menuTypes';

export interface MenuRoute {
  documentId: string;
  path: string;
  component: React.ReactNode;
  isMeetingRoom?: boolean;
}

export const useMenuRoutes = () => {
  const { menu } = useMenu();
  const [routes, setRoutes] = useState<MenuRoute[]>([]);

  useEffect(() => {
    const mapMenuToRoutes = (menuItems: MenuItem[]): MenuRoute[] => {
      return menuItems.reduce((acc: MenuRoute[], item: MenuItem) => {
        // Verifica se é um menu de reunião
        const isMeetingRoom = item.feature?.dynamic_component === 'MEETING_ROOM';
        const isMeetingRoomRoom = item.feature?.dynamic_component === 'MEETING_ROOM_ROOM';

        // Adiciona a rota do item atual
        if (item.feature?.documentId || (item.extras && isMeetingRoomExtras(item.extras))) {
          let documentId = item.feature?.documentId || '';

          // Se for uma sala de reunião, usa o internal_id
          /* if ((isMeetingRoom || isMeetingRoomRoom) && item.extras) {
            const extras = item.extras;
            if (isMeetingRoomExtras(extras)) {
              documentId = extras.internal_id || '';
            }
          } */

          if (documentId) {
            acc.push({
              documentId,
              path: item.path,
              component: null,
              isMeetingRoom: isMeetingRoom || isMeetingRoomRoom,
            });
          }
        }

        // Recursivamente mapeia submenus
        if (item.subMenu) {
          acc.push(...mapMenuToRoutes(item.subMenu));
        }

        return acc;
      }, []);
    };

    if (menu.length > 0) {
      const mappedRoutes = mapMenuToRoutes(menu);
      console.log('[MenuRoutes] Rotas mapeadas:', mappedRoutes);
      setRoutes(mappedRoutes);
    }
  }, [menu]);

  return routes;
};
